﻿<template>
    <h6 :hidden="this.$store.getters.get_Booking.notes.length == 0">Booking Notes</h6>
    <div class="grid grid-cols-2" v-for="booking_note in this.$store.getters.get_Booking.notes">
        <div>{{booking_note.type}}</div>
        <div>{{booking_note.note}}</div>
    </div>
</template>

<script lang="ts" src="./booking_notes.ts"></script>